module.exports = __webpack_public_path__ + "img/ch24.0b50cb44.jpg";